var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-splash',{attrs:{"show":true,"logo":_vm.logo,"title":"","color":"#109afd","size":300,"fixed":true}})}
var staticRenderFns = []

export { render, staticRenderFns }